import React, {CSSProperties, useEffect, useId} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {formatTime} from "utils/time-utils";
import {ComponentConfigDefault, HighlightMapped} from "models/dataset-models";
import {TitleOverrideAndDescriptionTemplate} from "../../templates/DataTableCellTemplates";
import {getValueColors} from "../product-template-table/utils/utils";

type DatasetTableTransposedProps = {
    data: Array<any>
    config: ComponentConfigDefault
    currentPage: number
    highlightRanges: Array<HighlightMapped>

    getPageDates: (page: number) => Array<string>
}

const DatasetTableTransposed = ({
                                    data,
                                    currentPage,
                                    getPageDates,
                                    config,
                                    highlightRanges
                                }: DatasetTableTransposedProps) => {
    const tableId = useId();

    useEffect(() => {
        if (config.hideDateColumn) {
            const table = document.getElementById(tableId);
            if (table) {
                const dateColumn = table.querySelector("thead");
                if (dateColumn) {
                    dateColumn.style.display = "none";
                }
            }
        }
    }, [config]);

    const setColors = (date: string, obj: any): CSSProperties | undefined => {
        const objValue = obj[date];


        const id = highlightRanges.find(e => e.identifier === obj.identifier)

        const [color, bgColor] = getValueColors(objValue, {
            highlightRanges: id?.highlightRanges,
            defaultHighlightColor: id?.defaultHighlight
        })

        return {color, backgroundColor: bgColor};
    }

    return <div className={"data-table-wrapper transposed-table"}>
        <DataTable value={data} size={"small"} showGridlines id={tableId}>
            <Column
                className={config.hideDateColumn ? "column-into-header column-dataset-table-transposed" : "column-dataset-table-transposed"}
                header={""} field={"title"}
                body={(row) => <div style={{padding: "6px"}}>
                    {
                        TitleOverrideAndDescriptionTemplate({
                            description: row.description,
                            title: row.title,
                            overriddenTitle: row.overriddenTitle,
                            unit: row.unit,
                            identifier: row.identifier
                        })}</div>}
                style={{whiteSpace: "nowrap"}}/>
            {
                getPageDates(currentPage).map(date => {
                    return <Column header={formatTime(date)}
                                   className={"column-dataset-table-transposed"}
                                   key={date}
                                   field={date}
                                   body={e => <div className={"column-with-padding-for-color"}
                                                   style={setColors(date, e)}>
                                       {e[date] != null ? e[date] : "-"}
                                   </div>}
                                   style={{width: 0, whiteSpace: "nowrap"}}
                    />
                })
            }
        </DataTable>
    </div>
};

export default DatasetTableTransposed;